import { Box, Button, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconMailFilled } from '@zillow/constellation-icons';

const MultifamilyDeactivationModal = ({
  setShowMultifamilyDeactivateModal,
}: {
  setShowMultifamilyDeactivateModal: (open: boolean) => void;
}) => (
  <Modal
    open={true}
    onOpenChange={(open) => !open && setShowMultifamilyDeactivateModal(false)}
    header={<Heading level={2}>Zillow support required</Heading>}
    footer={
      <Button onClick={() => setShowMultifamilyDeactivateModal(false)} tone="brand" emphasis="filled">
        OK
      </Button>
    }
    size={{ base: 'fullScreen', md: 'md' }}
    body={
      <div data-testid="MultifamilyDeactivationModal">
        <Box css={{ marginBottom: '600' }}>
          <Icon size="xl" css={{ color: 'icon.neutral' }} render={<IconMailFilled />} />
        </Box>
        <Heading level={2} css={{ marginBottom: '400', textStyle: 'heading-sm' }}>
          Contact a Zillow representative
        </Heading>
        <Paragraph>
          Your contract with Zillow requires that a Zillow representative assist you in deactivating this listing.
          Contact us for help with this task.
        </Paragraph>
      </div>
    }
  />
);

export default MultifamilyDeactivationModal;
